import { MDXProvider } from '@mdx-js/react';
import React from 'react';
import { Container } from 'rsuite';

import Gist from '../components/Gist/loadable';
import Header from '../components/PageLayout/Header';
import SidebarWrapper from '../components/PageLayout/Sidebar';

import { ContextProvider } from './context';

const shortcodes = { Gist };

/**
 * Wrap each Gatsby page with the shared academic site shell.
 */
export const wrapPageElement = ({ element, props }) => {
  const pathname = props?.location?.pathname || '';
  const isFullWidth = pathname.startsWith('/bookshelf') || pathname.startsWith('/calendar');
  const containerClassName = isFullWidth ? 'container containerFullWidth' : 'container';

  return (
    <ContextProvider>
      <MDXProvider components={shortcodes}>
        <Header />
        <Container className="outerPadding">
          <Container className={containerClassName}>
            {isFullWidth ? (
              <div>
                {element}
              </div>
            ) : (
              <SidebarWrapper>
                <div>
                  {element}
                </div>
              </SidebarWrapper>
            )}
          </Container>
        </Container>
      </MDXProvider>
    </ContextProvider>
  );
};

// const ThemeProvider = (props) => {
//   const [themeMode, setThemeMode] = useTheme();
//   return (
//     <CustomProvider theme={themeMode}>
//       {props.children}
//     </CustomProvider>
//   );
// };
//
// export const wrapRootElement = ({ element }) => {
//   return (
//     <ThemeProvider>
//       {element}
//     </ThemeProvider>
//   );
// };
